import { Box, Card, CardContent, CardHeader, Divider } from "@material-ui/core"
import React from "react"

export const DashPanel = ({ title, headerAction, children }: any) => {
  return (
    <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardHeader
        title={title}
        action={headerAction}
      />
      <Divider />
      <CardContent style={{ flex: 'auto' }}>
        <Box
          // height={400}
          position="relative"
        >
          {children}

        </Box>
      </CardContent>
      {/* <Divider />
      <Box
        display="flex"
        justifyContent="flex-end"
        p={2}
      >
        <Button
          color="primary"
          endIcon={<ArrowDownwardIcon />}
          size="small"
          variant="text"
        >
          Detalhes
        </Button>
      </Box> */}
    </Card>
  )
}